import { gql, useQuery } from '@apollo/client';
import { CrossClusterConnection } from '../utils';

export interface CrossClusterConnectionsVars {
  domainIdentifier: string;
  includeReplicationStats?: boolean;
}

export interface CrossClusterConnectionsData {
  crossClusterConnections: {
    outboundConnections: CrossClusterConnection[] | null;
    inboundConnections: CrossClusterConnection[] | null;
    followerStats?: any;
    leaderStats?: any;
    dataPlaneAvailable?: boolean;
  } | null;
}

export const CROSS_CLUSTER_CONNECTIONS = gql`
  query CrossClusterConnections($domainIdentifier: String!, $includeReplicationStats: Boolean, $piezoArtifacts: JSON) {
    crossClusterConnections(domainIdentifier: $domainIdentifier, includeReplicationStats: $includeReplicationStats, piezoArtifacts: $piezoArtifacts) {
      outboundConnections {
        connectionId
        connectionAlias
        connectionStatus
        connectionMode
        localDomainInfo {
          ownerId
          domainName
          region
        }
        remoteDomainInfo {
          ownerId
          domainName
          region
        }
      }
      inboundConnections {
        connectionId
        connectionAlias
        connectionStatus
        connectionMode
        localDomainInfo {
          ownerId
          domainName
          region
        }
        remoteDomainInfo {
          ownerId
          domainName
          region
        }
      }
      followerStats
      leaderStats
      dataPlaneAvailable
    }
  }
`;

export const useCrossClusterConnectionsQuery = (vars: CrossClusterConnectionsVars) => {
  return useQuery<CrossClusterConnectionsData, CrossClusterConnectionsVars>(
    CROSS_CLUSTER_CONNECTIONS,
    {
      variables: { ...vars },
      errorPolicy: 'all',
    }
  );
};
